import { DatePipe } from '@angular/common';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RefreshService {
  public refresh: EventEmitter<any> = new EventEmitter();

  private readonly datepipe: DatePipe = new DatePipe('en-US');
  private time: Date = null;

  constructor() {}

  public get isActive(): boolean {
    return this.time != null;
  }

  public get refreshTime(): string {
    return this.datepipe.transform(this.time, 'MMM d, h:mm a');
  }

  public handleRefresh(): void {
    this.time = new Date();
  }

  public requestRefresh(): void {
    this.refresh.emit();
  }
}
